import React, { useState } from "react";
import { Mail, Loader2, Check } from "lucide-react";
import { toast } from "sonner";

export const ToolEmailCapture = ({ id, title, text, button, reminderLabel, onSend, dark = false, disabled = false }) => {
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [reminder, setReminder] = useState(true);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await onSend({ email, consent, reminder });
      setDone(true);
      toast.success("C'est envoyé ! Pensez à vérifier vos courriers indésirables.");
    } catch (err) { toast.error(err?.response?.data?.detail || "Envoi impossible, réessayez."); }
    finally { setBusy(false); }
  };

  const muted = dark ? "text-white/70" : "text-brand-green/70";
  return (
    <form onSubmit={submit} className={`mt-6 rounded-2xl p-5 print:hidden ${dark ? "bg-white/10" : "bg-brand-softer border border-brand-soft"}`} data-testid={`${id}-capture`}>
      <p className={`flex items-center gap-2 font-semibold text-sm ${dark ? "text-brand-lime" : "text-brand-greenDeep"}`}><Mail className="w-4 h-4" /> {title}</p>
      <p className={`text-xs mt-1 ${muted}`}>{text}</p>
      {done ? (
        <p className={`mt-3 text-sm flex items-center gap-2 ${dark ? "text-white" : "text-emerald-700"}`} data-testid={`${id}-done`}><Check className="w-4 h-4" /> Envoyé à {email}</p>
      ) : (
        <>
          <div className="mt-3 flex gap-2">
            <input type="email" required placeholder="votre@email.fr" value={email} onChange={(e) => setEmail(e.target.value)} className="flex-1 min-w-0 px-3 py-2.5 rounded-full border border-brand-soft bg-white outline-none focus:border-brand-lime text-sm text-brand-greenDeep" data-testid={`${id}-email`} />
            <button type="submit" disabled={busy || disabled || !email} className="shrink-0 inline-flex items-center gap-2 px-4 rounded-full bg-brand-lime hover:bg-brand-limeDark text-brand-greenDeep text-sm font-semibold disabled:opacity-60" data-testid={`${id}-send`}>{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : button}</button>
          </div>
          {reminderLabel && (
            <label className={`mt-3 flex items-start gap-2 text-xs cursor-pointer ${muted}`}><input type="checkbox" checked={reminder} onChange={(e) => setReminder(e.target.checked)} className="mt-0.5 accent-brand-lime" data-testid={`${id}-reminder`} /> {reminderLabel}</label>
          )}
          <label className={`mt-2 flex items-start gap-2 text-xs cursor-pointer ${muted}`}><input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5 accent-brand-lime" data-testid={`${id}-consent`} /> J'accepte aussi de recevoir la newsletter de 360immoinvest (facultatif, désinscription en un clic).</label>
        </>
      )}
    </form>
  );
};
